import { at } from "lodash";
import { useField } from "formik";
import { useState } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
interface Props {
  id: string;
  data: any;
  name: string;
  label?: string;
  style?: any;
  onChange?: (e: any) => void;
  onChangeHandle?: (e: any) => void;
  parentCallBack?: (e: any) => void;
  className?: any;
  disabled?: any;
  value?: any;
  defaultValue?: any;
  optionColor?: any;
  errorMessage?: any;
}

function DRxSelect(props: Props) {
  const [field, meta, helpers] = useField(props);
  const { value: selectedValue } = field;
  const [optionColorClass, setOptionColorClass] = useState("");
  const { setValue } = helpers;
  const [touched, error] = at(meta, "touched", "error");
  const isError = touched && error;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 4;
  const MenuProps = {
    PaperProps: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left",
      },
      style: {
        maxHeight: ITEM_HEIGHT * 3 + ITEM_PADDING_TOP,
        maxWidth: 150,
      },
    },
  };
  return (
    <FormControl {...props} error={isError}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        {...field}
        onChange={(e) => {
          setValue(e.target.value);
          if (props.parentCallBack) {
            props.parentCallBack(e);
          }
        }}
        value={selectedValue ? selectedValue : ""}
        className={optionColorClass}
        sx={{
          borderRadius: 100,
        }}
        MenuProps={MenuProps}
      >
        {props.data.map((item: any) => (
          <MenuItem
            key={item.value}
            value={item.value}
            className={item.optionColor}
            onClick={() => {
              setOptionColorClass(item.optionColor);
            }}
            disabled={item?.disabled}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>{" "}
      {props.errorMessage && (
        <Typography
          color="error"
          className="error"
          variant="body2"
          component="div"
        >
          {props.errorMessage}
          {/* <ErrorMessage name={props.name} /> */}
        </Typography>
      )}
    </FormControl>
  );
}

export default DRxSelect;
